// extracted by mini-css-extract-plugin
export default {"btnpwd":"_9f15687b4c"};